import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Package2Header from "./Package2Header";
import PackageCreate from "./PackageCreate";

const Package = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Package2Header />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <PackageCreate />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Package;
